import React, { useEffect, useRef, useState } from "react";
import Container from "../../components/container";
import EmptyButton from "../../components/EmptyButton";
import { IoMdSend } from "react-icons/io";
import ChatSidebar from "../../components/ChatComponents/ChatSideBar";
import { ChatInterface } from "../../components/ChatComponents/ChatInterface";

const TOKENS_PER_MILLION = 1000000;
const CREDITS_PER_MILLION_TOKENS = 19.11;

const AITutor = () => {

  const backendUrl = 'http://195.26.232.151:38613';
  const allowedTypes = [
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'text/plain',
    'image/png',
    'image/jpeg',
  ];

  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [sessions, setSessions] = useState([]);
  const [userId, setUserId] = useState(null);

  const user = JSON.parse(sessionStorage.getItem('app_user'))
  const [session_id, setSesionId] = useState('')

  const messageContainer = useRef()

  const credits = Math.round(
    ((Number(user?.total_tokens) || 0) / TOKENS_PER_MILLION) *
      CREDITS_PER_MILLION_TOKENS
  );

  const handleProfileClick = () => {
    console.log("Profile clicked");
  };

  const handleLogoutClick = () => {
    console.log("Logout clicked");
  };

  useEffect(() => {
    if (messageContainer.current) {
      messageContainer.current.scrollTop = messageContainer.current.scrollHeight;
    }
  }, [messages]);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get('user_id') || params.get('userid');
    const sesion = params.get('session_id');
    
    // Set session ID (default to '1245' if not found)
    setSesionId(sesion || '1245');

    if (id && params.get('userid')) {
      // Replace 'userid' param with 'user_id' in the URL
      const newUrl = new URL(window.location);
      newUrl.searchParams.set('user_id', id);
      newUrl.searchParams.delete('userid');
      window.history.replaceState({}, '', newUrl);
    }

    // Set the user ID state
    setUserId(id || null);

    // Fetch session data directly using the URL param 'user_id'
    const fetchSession = async () => {
      if (id) {
        try {
          const res = await fetch(`https://aibackend.studycrowdai.us/v1/sessions/latest?user_id=${id}`);
          const session = await res.json();
          console.log('Fetched Session:', session);
          setSesionId(session.id)
          const newUrl = new URL(window.location);
          newUrl.searchParams.set('session_id', session.id);
          window.history.replaceState({}, '', newUrl);

          // Proceed with session-related logic here
          await fetchMessages(session.id);
        } catch (error) {
          console.error('Error fetching session:', error);
        }
      }
    };

    fetchSession();

  }, [user.id]); 

  useEffect(() => {
    const fetchSessions = async () => {
      let uid = ''
      const user_Id = String(userId); // Ensures it's a string
      const res = await fetch(`
https://aibackend.studycrowdai.us/v1/sessions?user_id=${userId}`);
      const data = await res.json();
      setSessions(data);
    };
    fetchSessions()
  },[])

  const fetchMessages = async (sessionId) => {
    const res = await fetch(`https://aibackend.studycrowdai.us/v1/messages?session_id=${sessionId}&user_id=${user?.id}`);
    const { messages } = await res.json();
    setMessages((prevMessages) => [
      ...prevMessages, // Keep the existing messages
      ...messages.map((msg) => ({
        from: msg.role === 'user' ? 'user' : 'ai', // Map the new messages
        text: msg.content,
      })),
    ]);
      };

  const handleSend = async () => {
    if (input.trim() === "") return; // Prevent sending empty messages
  
    // Append the user message
    setMessages((prevMessages) => [
      ...prevMessages, // Retain the previous messages
      { from: "user", text: input }, // Add user message
    ]);
  
    // Clear the input field
    setInput("");
  
    // Create FormData for sending to the server
    const formData = new FormData();
    formData.append('user_id', userId);
    formData.append('session_id', session_id);
    formData.append('prompt', input || '');
  
    try {
      // Send the user input to the AI backend
      const response = await fetch(`https://aibackend.studycrowdai.us/v1/chat`, {
        method: 'POST',
        body: formData,
      });
  
      // Parse the response JSON
      const res = await response.json();
  
      // Append the AI response
      setMessages((prevMessages) => [
        ...prevMessages, // Retain the previous messages
        { from: "ai", text: res?.response || "No response from AI" }, // Add AI message
      ]);
    } catch (error) {
      console.error("Error fetching AI response:", error);
    }
  };
  

  return (
      <div className="flex min-h-screen bg-background">
      <ChatSidebar 
        credits={credits}
        onProfileClick={handleProfileClick}
        onLogoutClick={handleLogoutClick}
      />
      <ChatInterface credits={credits} />
    </div>
  );
};

export default AITutor;
